module.exports = __webpack_public_path__ + "img/ModuleStatistics.06e576eb.png";